// extracted by mini-css-extract-plugin
export default {"customers":"fQ","wrapper":"gQ","carousel":"hQ","carousel_inner_wrapper":"iQ","top_quote":"jQ","bottom_quote":"kQ","carousel_wrapper":"lQ","feedbacks_wrapper":"mQ","arrows":"nQ","prev":"oQ","img":"pQ","review_btn":"qQ"};
    if(module.hot) {
      // 1714654894551
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  